module.exports = __webpack_public_path__ + "static/media/ayo-ogunseinde-2.bfc688ca.jpg";